import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTrack } from './TrackLayout';
import { trackApi, errMsg } from '../../lib/trackApi';
import { C, btn, btnGhost, btnSm, input as inputStyle, card } from '../../components/track/trackUi';

export default function TrackBoards() {
  const { boards, reloadMeta } = useTrack();
  const [name, setName] = useState('');
  const [desc, setDesc] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const create = async () => {
    if (!name.trim()) return;
    setBusy(true);
    setError('');
    try {
      await trackApi.createBoard({ name: name.trim(), description: desc.trim() });
      setName('');
      setDesc('');
      await reloadMeta();
    } catch (e) {
      setError(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  const toggle = async (b) => {
    try {
      await trackApi.patchBoard(b.id, { isActive: !b.isActive });
      await reloadMeta();
    } catch (e) {
      setError(errMsg(e));
    }
  };

  return (
    <div style={{ maxWidth: 960 }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 14 }}>
        <input style={{ ...inputStyle, minWidth: 180 }} placeholder="看板名稱" value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && create()} />
        <input style={{ ...inputStyle, flex: 1, minWidth: 200 }} placeholder="說明（選填）" value={desc} onChange={(e) => setDesc(e.target.value)} />
        <button type="button" style={btn} disabled={busy || !name.trim()} onClick={create}>新增看板</button>
      </div>
      {error && <div style={{ color: C.danger, marginBottom: 10 }}>{error}</div>}
      {!boards.length && <div style={{ color: C.muted }}>尚無看板</div>}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 12 }}>
        {boards.map((b) => (
          <div key={b.id} style={{ ...card, opacity: b.isActive ? 1 : 0.55 }}>
            <Link to={`${b.id}`} style={{ fontWeight: 800, fontSize: 16, color: C.brandDark, textDecoration: 'none' }}>{b.name}</Link>
            {b.description && <div style={{ fontSize: 12, color: C.muted, marginTop: 4 }}>{b.description}</div>}
            <div style={{ fontSize: 12, color: C.muted, marginTop: 8 }}>
              {b.lineGroupId ? 'LINE 群組已綁定' : '未綁定 LINE 群組'}
              {b.dailyNotifyEnabled ? `・每日 ${b.dailyNotifyHhmm} 通知` : ''}
            </div>
            <div style={{ display: 'flex', gap: 6, marginTop: 10 }}>
              <Link to={`${b.id}`} style={{ ...btn, ...btnSm, textDecoration: 'none' }}>開啟</Link>
              <button type="button" style={{ ...btnGhost, ...btnSm }} onClick={() => toggle(b)}>{b.isActive ? '封存' : '啟用'}</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
